const UploadMedia = async (url: string, data: Blob | File | BufferSource): Promise<string> => {
  if (!url || typeof url !== "string") {
    throw new Error("UploadMedia: missing pre-signed URL");
  }
  const res = await fetch(url, {
    method: "PUT",
    body: data,
  });
  if (!res.ok) {
    const snippet = await res.text().catch(() => "");
    throw new Error(
      `Pre-signed upload failed (${res.status} ${res.statusText})${snippet ? `: ${snippet.slice(0, 300)}` : ""}`
    );
  }
  return url;
};

export default UploadMedia;
